import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Popover } from 'react-bootstrap';
import { getPageStatusProps, getPageStatusShorthand } from 'utils/pageStatus';
import Icon from 'modules/react/components/stateless/Icon';
import { LANGUAGE_NAME_MAPPING } from 'shared/i18n';
import style from './PageStatus.scss';

const propTypes = {
  children: PropTypes.arrayOf(PropTypes.object),
  live: PropTypes.bool.isRequired,
  locale: PropTypes.string,
  status: PropTypes.object,
  unpublishedChanges: PropTypes.bool.isRequired,
  languages: PropTypes.array.isRequired,
  nonDefaultLanguages: PropTypes.array.isRequired,
};

const PageStatus = ({
  live,
  locale,
  unpublishedChanges,
  children,
  languages,
  nonDefaultLanguages,
}) => {
  const status = getPageStatusProps({ live, unpublishedChanges, key: 'id' });

  const renderChild = (child, idx) => {
    const languageEnabled = !!languages.find(({ code }) => code === child.locale);

    return (
      <div className={style.size15SVG} key={`status-popover-${idx}-${locale}`}>
        {languageEnabled &&
          <React.Fragment>
            <Icon
              label="page status"
              {...child.status}
            />{LANGUAGE_NAME_MAPPING[child.locale]}
          </React.Fragment>
        }
      </div>
    );
  };

  const nonDefaultLanguagesTooltip = (
    <Popover
      className="pageStatusTooltip"
      id="multiLangPageStatus"
    >
      <div className={style.popover}>
        <div className={style.popoverTitle}>Page Statuses Per Language</div>
        <div className={style.list}>
          {renderChild({ locale, status })}
          {children.map(renderChild)}
        </div>
      </div>
    </Popover>
  );

  const defaultLanguageTooltip = (
    <Popover
      className="pageStatusTooltip"
      id="pageStatus"
    >
      {getPageStatusShorthand({ live, unpublishedChanges })}
    </Popover>
  );

  const tooltip = nonDefaultLanguages.length
    ? nonDefaultLanguagesTooltip
    : defaultLanguageTooltip;

  return (
    <div>
      <OverlayTrigger
        placement={nonDefaultLanguages.length ? 'right' : 'bottom'}
        overlay={tooltip}
      >
        <div className={style.size20SVG}>
          <Icon
            label="page status"
            {...status}
          />
        </div>
      </OverlayTrigger>
    </div>
  );
};

PageStatus.propTypes = propTypes;

export default PageStatus;
